/* AUTO-GENERATED - COMPILED FROM TYPESCRIPT, DO NOT EDIT DIRECTLY */
function t(t, e) {
    const n = t.indexOf(e);
    n > -1 && t.splice(n, 1);
}
const e = (t, e, n) => Math.min(Math.max(n, t), e),
    n = { duration: 0.3, delay: 0, endDelay: 0, repeat: 0, easing: 'ease' },
    i = t => 'number' == typeof t,
    r = t => Array.isArray(t) && !i(t[0]);
function o(t, e) {
    return r(t)
        ? t[
              ((t, e, n) => {
                  const i = e - t;
                  return ((((n - t) % i) + i) % i) + t;
              })(0, t.length, e)
          ]
        : t;
}
const s = (t, e, n) => -n * t + n * e + t,
    a = () => {},
    l = t => t,
    c = (t, e, n) => (e - t === 0 ? 1 : (n - t) / (e - t));
function u(t, e) {
    const n = t[t.length - 1];
    for (let i = 1; i <= e; i++) {
        const r = c(0, e, i);
        t.push(s(n, 1, r));
    }
}
function d(t) {
    const e = [0];
    return u(e, t - 1), e;
}
function h(t, n = d(t.length), i = l) {
    const r = t.length,
        a = r - n.length;
    return (
        a > 0 && u(n, a),
        a => {
            let l = 0;
            for (; l < r - 2 && !(a < n[l + 1]); l++);
            let u = e(0, 1, c(n[l], n[l + 1], a));
            return (u = o(i, l)(u)), s(t[l], t[l + 1], u);
        }
    );
}
const f = t => Array.isArray(t) && i(t[0]),
    p = t => 'object' == typeof t && Boolean(t.createAnimation),
    m = t => 'function' == typeof t,
    v = t => 'string' == typeof t,
    y = t => 1e3 * t,
    g = t => t / 1e3;
function b(t, e) {
    return e ? t * (1e3 / e) : 0;
}
const w = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t;
function S(t, e, n, i) {
    if (t === e && n === i) return l;
    const r = e =>
        (function (t, e, n, i, r) {
            let o,
                s,
                a = 0;
            do {
                (s = e + (n - e) / 2), (o = w(s, i, r) - t), o > 0 ? (n = s) : (e = s);
            } while (Math.abs(o) > 1e-7 && ++a < 12);
            return s;
        })(e, 0, 1, t, n);
    return t => (0 === t || 1 === t ? t : w(r(t), e, i));
}
const E = {
        ease: S(0.25, 0.1, 0.25, 1),
        'ease-in': S(0.42, 0, 1, 1),
        'ease-in-out': S(0.42, 0, 0.58, 1),
        'ease-out': S(0, 0, 0.58, 1),
    },
    O = /\((.*?)\)/;
function T(t) {
    if (m(t)) return t;
    if (f(t)) return S(...t);
    const n = E[t];
    if (n) return n;
    if (t.startsWith('steps')) {
        const n = O.exec(t);
        if (n) {
            const t = n[1].split(',');
            return (
                (t, n = 'end') =>
                i => {
                    const r = (i = 'end' === n ? Math.min(i, 0.999) : Math.max(i, 0.001)) * t,
                        o = 'end' === n ? Math.floor(r) : Math.ceil(r);
                    return e(0, 1, o / t);
                }
            )(parseFloat(t[0]), t[1].trim());
        }
    }
    return l;
}
class x {
    constructor(
        t,
        e = [0, 1],
        {
            easing: i,
            duration: o = n.duration,
            delay: s = n.delay,
            endDelay: a = n.endDelay,
            repeat: c = n.repeat,
            offset: u,
            direction: d = 'normal',
            autoplay: f = !0,
        } = {}
    ) {
        if (
            ((this.startTime = null),
            (this.rate = 1),
            (this.t = 0),
            (this.cancelTimestamp = null),
            (this.easing = l),
            (this.duration = 0),
            (this.totalDuration = 0),
            (this.repeat = 0),
            (this.playState = 'idle'),
            (this.finished = new Promise((t, e) => {
                (this.resolve = t), (this.reject = e);
            })),
            (i = i || n.easing),
            p(i))
        ) {
            const t = i.createAnimation(e);
            (i = t.easing), (e = t.keyframes || e), (o = t.duration || o);
        }
        (this.repeat = c), (this.easing = r(i) ? l : T(i)), this.updateDuration(o);
        const m = h(e, u, r(i) ? i.map(T) : l);
        (this.tick = e => {
            var n;
            let i = 0;
            (i = void 0 !== this.pauseTime ? this.pauseTime : (e - this.startTime) * this.rate),
                (this.t = i),
                (i /= 1e3),
                (i = Math.max(i - s, 0)),
                'finished' === this.playState &&
                    void 0 === this.pauseTime &&
                    (i = this.totalDuration);
            const r = i / this.duration;
            let o = Math.floor(r),
                l = r % 1;
            !l && r >= 1 && (l = 1), 1 === l && o--;
            const c = o % 2;
            ('reverse' === d || ('alternate' === d && c) || ('alternate-reverse' === d && !c)) &&
                (l = 1 - l);
            const u = i >= this.totalDuration ? 1 : Math.min(l, 1),
                h = m(this.easing(u));
            t(h);
            void 0 === this.pauseTime &&
            ('finished' === this.playState || i >= this.totalDuration + a)
                ? ((this.playState = 'finished'),
                  null === (n = this.resolve) || void 0 === n || n.call(this, h))
                : 'idle' !== this.playState &&
                  (this.frameRequestId = requestAnimationFrame(this.tick));
        }),
            f && this.play();
    }
    play() {
        const t = performance.now();
        (this.playState = 'running'),
            void 0 !== this.pauseTime
                ? (this.startTime = t - this.pauseTime)
                : this.startTime || (this.startTime = t),
            (this.cancelTimestamp = this.startTime),
            (this.pauseTime = void 0),
            (this.frameRequestId = requestAnimationFrame(this.tick));
    }
    pause() {
        (this.playState = 'paused'), (this.pauseTime = this.t);
    }
    finish() {
        (this.playState = 'finished'), this.tick(0);
    }
    stop() {
        var t;
        (this.playState = 'idle'),
            void 0 !== this.frameRequestId && cancelAnimationFrame(this.frameRequestId),
            null === (t = this.reject) || void 0 === t || t.call(this, !1);
    }
    cancel() {
        this.stop(), this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(t) {
        (this.duration = t), (this.totalDuration = t * (this.repeat + 1));
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        void 0 !== this.pauseTime || 0 === this.rate
            ? (this.pauseTime = t)
            : (this.startTime = performance.now() - t / this.rate);
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(t) {
        this.rate = t;
    }
}
var P = function () {};
class A {
    setAnimation(t) {
        (this.animation = t),
            null == t || t.finished.then(() => this.clearAnimation()).catch(() => {});
    }
    clearAnimation() {
        this.animation = this.generator = void 0;
    }
}
const I = new WeakMap();
function N(t) {
    return I.has(t) || I.set(t, { transforms: [], values: new Map() }), I.get(t);
}
const D = ['', 'X', 'Y', 'Z'],
    F = { x: 'translateX', y: 'translateY', z: 'translateZ' },
    k = { syntax: '<angle>', initialValue: '0deg', toDefaultUnit: t => t + 'deg' },
    _ = {
        translate: {
            syntax: '<length-percentage>',
            initialValue: '0px',
            toDefaultUnit: t => t + 'px',
        },
        rotate: k,
        scale: { syntax: '<number>', initialValue: 1, toDefaultUnit: l },
        skew: k,
    },
    L = new Map(),
    M = t => `--motion-${t}`,
    C = ['x', 'y', 'z'];
['translate', 'scale', 'rotate', 'skew'].forEach(t => {
    D.forEach(e => {
        C.push(t + e), L.set(M(t + e), _[t]);
    });
});
const R = (t, e) => C.indexOf(t) - C.indexOf(e),
    z = new Set(C),
    j = t => z.has(t),
    G = t => t.sort(R).reduce(W, '').trim(),
    W = (t, e) => `${t} ${e}(var(${M(e)}))`,
    B = t => t.startsWith('--'),
    $ = new Set();
const q = (t, e) => document.createElement('div').animate(t, e),
    U = {
        cssRegisterProperty: () =>
            'undefined' != typeof CSS && Object.hasOwnProperty.call(CSS, 'registerProperty'),
        waapi: () => Object.hasOwnProperty.call(Element.prototype, 'animate'),
        partialKeyframes: () => {
            try {
                q({ opacity: [1] });
            } catch (t) {
                return !1;
            }
            return !0;
        },
        finished: () => Boolean(q({ opacity: [0, 1] }, { duration: 0.001 }).finished),
        linearEasing: () => {
            try {
                q({ opacity: 0 }, { easing: 'linear(0, 1)' });
            } catch (t) {
                return !1;
            }
            return !0;
        },
    },
    H = {},
    V = {};
for (const mn in U) V[mn] = () => (void 0 === H[mn] && (H[mn] = U[mn]()), H[mn]);
const K = (t, e) =>
        m(t)
            ? V.linearEasing()
                ? `linear(${((t, e) => {
                      let n = '';
                      const i = Math.round(e / 0.015);
                      for (let r = 0; r < i; r++) n += t(c(0, i - 1, r)) + ', ';
                      return n.substring(0, n.length - 2);
                  })(t, e)})`
                : n.easing
            : f(t)
              ? Z(t)
              : t,
    Z = ([t, e, n, i]) => `cubic-bezier(${t}, ${e}, ${n}, ${i})`;
const Y = t => (Array.isArray(t) ? t : [t]);
function X(t) {
    return F[t] && (t = F[t]), j(t) ? M(t) : t;
}
const J = (t, e) => {
        e = X(e);
        let n = B(e) ? t.style.getPropertyValue(e) : getComputedStyle(t)[e];
        if (!n && 0 !== n) {
            const t = L.get(e);
            t && (n = t.initialValue);
        }
        return n;
    },
    Q = (t, e, n) => {
        (e = X(e)), B(e) ? t.style.setProperty(e, n) : (t.style[e] = n);
    };
function tt(t, e = !0) {
    if (t && 'finished' !== t.playState)
        try {
            t.stop ? t.stop() : (e && t.commitStyles(), t.cancel());
        } catch (n) {}
}
function et(t, e) {
    var n;
    let i = (null == e ? void 0 : e.toDefaultUnit) || l;
    const r = t[t.length - 1];
    if (v(r)) {
        const t =
            (null === (n = r.match(/(-?[\d.]+)([a-z%]*)/)) || void 0 === n ? void 0 : n[2]) || '';
        t && (i = e => e + t);
    }
    return i;
}
function nt(t, e, o, s = {}, l) {
    const c = window.__MOTION_DEV_TOOLS_RECORD,
        u = !1 !== s.record && c;
    let d,
        {
            duration: h = n.duration,
            delay: f = n.delay,
            endDelay: v = n.endDelay,
            repeat: g = n.repeat,
            easing: b = n.easing,
            persist: w = !1,
            direction: S,
            offset: E,
            allowWebkitAcceleration: O = !1,
            autoplay: T = !0,
        } = s;
    const x = N(t),
        P = j(e);
    let I = V.waapi();
    P &&
        ((t, e) => {
            F[e] && (e = F[e]);
            const { transforms: n } = N(t);
            var i, r;
            (r = e), -1 === (i = n).indexOf(r) && i.push(r), (t.style.transform = G(n));
        })(t, e);
    const D = X(e),
        k = (function (t, e) {
            return t.has(e) || t.set(e, new A()), t.get(e);
        })(x.values, D),
        _ = L.get(D);
    return (
        tt(k.animation, !(p(b) && k.generator) && !1 !== s.record),
        () => {
            const n = () => {
                var e, n;
                return null !==
                    (n =
                        null !== (e = J(t, D)) && void 0 !== e
                            ? e
                            : null == _
                              ? void 0
                              : _.initialValue) && void 0 !== n
                    ? n
                    : 0;
            };
            let x = (function (t, e) {
                for (let n = 0; n < t.length; n++) null === t[n] && (t[n] = n ? t[n - 1] : e());
                return t;
            })(Y(o), n);
            const A = et(x, _);
            if (p(b)) {
                const t = b.createAnimation(x, 'opacity' !== e, n, D, k);
                (b = t.easing), (x = t.keyframes || x), (h = t.duration || h);
            }
            if (
                (B(D) &&
                    (V.cssRegisterProperty()
                        ? (function (t) {
                              if (!$.has(t)) {
                                  $.add(t);
                                  try {
                                      const { syntax: e, initialValue: n } = L.has(t)
                                          ? L.get(t)
                                          : {};
                                      CSS.registerProperty({
                                          name: t,
                                          inherits: !1,
                                          syntax: e,
                                          initialValue: n,
                                      });
                                  } catch (e) {}
                              }
                          })(D)
                        : (I = !1)),
                P && !V.linearEasing() && (m(b) || (r(b) && b.some(m))) && (I = !1),
                I)
            ) {
                _ && (x = x.map(t => (i(t) ? _.toDefaultUnit(t) : t))),
                    1 !== x.length || (V.partialKeyframes() && !u) || x.unshift(n());
                const e = {
                    delay: y(f),
                    duration: y(h),
                    endDelay: y(v),
                    easing: r(b) ? void 0 : K(b, h),
                    direction: S,
                    iterations: g + 1,
                    fill: 'both',
                };
                (d = t.animate(
                    { [D]: x, offset: E, easing: r(b) ? b.map(t => K(t, h)) : void 0 },
                    e
                )),
                    d.finished ||
                        (d.finished = new Promise((t, e) => {
                            (d.onfinish = t), (d.oncancel = e);
                        }));
                const o = x[x.length - 1];
                d.finished
                    .then(() => {
                        w || (Q(t, D, o), d.cancel());
                    })
                    .catch(a),
                    O || (d.playbackRate = 1.000001);
            } else if (l && P)
                (x = x.map(t => ('string' == typeof t ? parseFloat(t) : t))),
                    1 === x.length && x.unshift(parseFloat(n())),
                    (d = new l(
                        e => {
                            Q(t, D, A ? A(e) : e);
                        },
                        x,
                        Object.assign(Object.assign({}, s), { duration: h, easing: b })
                    ));
            else {
                const e = x[x.length - 1];
                Q(t, D, _ && i(e) ? _.toDefaultUnit(e) : e);
            }
            return (
                u &&
                    c(
                        t,
                        e,
                        x,
                        { duration: h, delay: f, easing: b, repeat: g, offset: E },
                        'motion-one'
                    ),
                k.setAnimation(d),
                d && !T && d.pause(),
                d
            );
        }
    );
}
const it = (t, e) => (t[e] ? Object.assign(Object.assign({}, t), t[e]) : Object.assign({}, t));
function rt(t, e) {
    var n;
    return (
        'string' == typeof t
            ? e
                ? ((null !== (n = e[t]) && void 0 !== n) || (e[t] = document.querySelectorAll(t)),
                  (t = e[t]))
                : (t = document.querySelectorAll(t))
            : t instanceof Element && (t = [t]),
        Array.from(t || [])
    );
}
const ot = t => t(),
    st = (t, e, i = n.duration) =>
        new Proxy({ animations: t.map(ot).filter(Boolean), duration: i, options: e }, at),
    at = {
        get: (t, e) => {
            const n = t.animations[0];
            switch (e) {
                case 'duration':
                    return t.duration;
                case 'currentTime':
                    return g((null == n ? void 0 : n[e]) || 0);
                case 'playbackRate':
                case 'playState':
                    return null == n ? void 0 : n[e];
                case 'finished':
                    return (
                        t.finished || (t.finished = Promise.all(t.animations.map(lt)).catch(a)),
                        t.finished
                    );
                case 'stop':
                    return () => {
                        t.animations.forEach(t => tt(t));
                    };
                case 'forEachNative':
                    return e => {
                        t.animations.forEach(n => e(n, t));
                    };
                default:
                    return void 0 === (null == n ? void 0 : n[e])
                        ? void 0
                        : () => t.animations.forEach(t => t[e]());
            }
        },
        set: (t, e, n) => {
            switch (e) {
                case 'currentTime':
                    n = y(n);
                case 'playbackRate':
                    for (let i = 0; i < t.animations.length; i++) t.animations[i][e] = n;
                    return !0;
            }
            return !1;
        },
    },
    lt = t => t.finished;
function ct(t = 0.1, { start: e = 0, from: n = 0, easing: r } = {}) {
    return (o, s) => {
        const a = i(n)
                ? n
                : (function (t, e) {
                      if ('first' === t) return 0;
                      {
                          const n = e - 1;
                          return 'last' === t ? n : n / 2;
                      }
                  })(n, s),
            l = Math.abs(a - o);
        let c = t * l;
        if (r) {
            const e = s * t;
            c = T(r)(c / e) * e;
        }
        return e + c;
    };
}
function ut(t, e, n) {
    return m(t) ? t(e, n) : t;
}
const dt =
    ((ht = x),
    function (t, e, n = {}) {
        const i = (t = rt(t)).length,
            r = [];
        for (let o = 0; o < i; o++) {
            const s = t[o];
            for (const t in e) {
                const a = it(n, t);
                a.delay = ut(a.delay, o, i);
                const l = nt(s, t, e[t], a, ht);
                r.push(l);
            }
        }
        return st(r, n, n.duration);
    });
var ht;
function ft(t, e) {
    var n = {};
    for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
    if (null != t && 'function' == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for (i = Object.getOwnPropertySymbols(t); r < i.length; r++)
            e.indexOf(i[r]) < 0 &&
                Object.prototype.propertyIsEnumerable.call(t, i[r]) &&
                (n[i[r]] = t[i[r]]);
    }
    return n;
}
function pt(t, e, n, r) {
    var o;
    return i(e)
        ? e
        : e.startsWith('-') || e.startsWith('+')
          ? Math.max(0, t + parseFloat(e))
          : '<' === e
            ? n
            : null !== (o = r.get(e)) && void 0 !== o
              ? o
              : t;
}
function mt(e, n, i, r, a, l) {
    !(function (e, n, i) {
        for (let r = 0; r < e.length; r++) {
            const o = e[r];
            o.at > n && o.at < i && (t(e, o), r--);
        }
    })(e, a, l);
    for (let t = 0; t < n.length; t++) e.push({ value: n[t], at: s(a, l, r[t]), easing: o(i, t) });
}
function vt(t, e) {
    return t.at === e.at ? (null === t.value ? 1 : -1) : t.at - e.at;
}
function yt(t, e = {}) {
    var i;
    const r = (function (t, e = {}) {
            var { defaultOptions: i = {} } = e,
                r = ft(e, ['defaultOptions']);
            const o = [],
                s = new Map(),
                a = {},
                l = new Map();
            let h = 0,
                f = 0,
                m = 0;
            for (let c = 0; c < t.length; c++) {
                const e = t[c];
                if (v(e)) {
                    l.set(e, f);
                    continue;
                }
                if (!Array.isArray(e)) {
                    l.set(e.name, pt(f, e.at, h, l));
                    continue;
                }
                const [r, o, y = {}] = e;
                void 0 !== y.at && (f = pt(f, y.at, h, l));
                let g = 0;
                const b = rt(r, a),
                    w = b.length;
                for (let t = 0; t < w; t++) {
                    const e = gt(b[t], s);
                    for (const r in o) {
                        const s = bt(r, e);
                        let a = Y(o[r]);
                        const l = it(y, r);
                        let {
                            duration: c = i.duration || n.duration,
                            easing: h = i.easing || n.easing,
                        } = l;
                        if (p(h)) {
                            P('opacity' === r || a.length);
                            const t = h.createAnimation(a, 'opacity' !== r, () => 0, r);
                            (h = t.easing), (a = t.keyframes || a), (c = t.duration || c);
                        }
                        const v = ut(y.delay, t, w) || 0,
                            b = f + v,
                            S = b + c;
                        let { offset: E = d(a.length) } = l;
                        1 === E.length && 0 === E[0] && (E[1] = 1);
                        const O = E.length - a.length;
                        O > 0 && u(E, O),
                            1 === a.length && a.unshift(null),
                            mt(s, a, h, E, b, S),
                            (g = Math.max(v + c, g)),
                            (m = Math.max(S, m));
                    }
                }
                (h = f), (f += g);
            }
            return (
                s.forEach((t, e) => {
                    for (const s in t) {
                        const a = t[s];
                        a.sort(vt);
                        const l = [],
                            u = [],
                            d = [];
                        for (let t = 0; t < a.length; t++) {
                            const { at: e, value: i, easing: r } = a[t];
                            l.push(i), u.push(c(0, m, e)), d.push(r || n.easing);
                        }
                        0 !== u[0] && (u.unshift(0), l.unshift(l[0]), d.unshift('linear')),
                            1 !== u[u.length - 1] && (u.push(1), l.push(null)),
                            o.push([
                                e,
                                s,
                                l,
                                Object.assign(
                                    Object.assign(Object.assign({}, i), {
                                        duration: m,
                                        easing: d,
                                        offset: u,
                                    }),
                                    r
                                ),
                            ]);
                    }
                }),
                o
            );
        })(t, e),
        o = r.map(t => nt(...t, x)).filter(Boolean);
    return st(o, e, null === (i = r[0]) || void 0 === i ? void 0 : i[3].duration);
}
function gt(t, e) {
    return !e.has(t) && e.set(t, {}), e.get(t);
}
function bt(t, e) {
    return e[t] || (e[t] = []), e[t];
}
'function' == typeof SuppressedError && SuppressedError;
function wt(t, e, n) {
    const i = Math.max(e - 5, 0);
    return b(n - t(i), e - i);
}
const St = 100,
    Et = 10,
    Ot = 1;
function Tt(t) {
    return i(t) && !isNaN(t);
}
function xt(t) {
    return v(t) ? parseFloat(t) : t;
}
const Pt = (function (t) {
        const e = new WeakMap();
        return (n = {}) => {
            const i = new Map(),
                r = (e = 0, r = 100, o = 0, s = !1) => {
                    const a = `${e}-${r}-${o}-${s}`;
                    return (
                        i.has(a) || i.set(a, t(Object.assign({ from: e, to: r, velocity: o }, n))),
                        i.get(a)
                    );
                },
                o = (t, n) => (
                    e.has(t) ||
                        e.set(
                            t,
                            (function (t, e = l) {
                                let n,
                                    i = 10,
                                    r = t(0);
                                const o = [e(r.current)];
                                for (; !r.done && i < 1e4; )
                                    (r = t(i)),
                                        o.push(e(r.done ? r.target : r.current)),
                                        void 0 === n && r.hasReachedTarget && (n = i),
                                        (i += 10);
                                const s = i - 10;
                                return (
                                    1 === o.length && o.push(r.current),
                                    {
                                        keyframes: o,
                                        duration: s / 1e3,
                                        overshootDuration: (null != n ? n : s) / 1e3,
                                    }
                                );
                            })(t, n)
                        ),
                    e.get(t)
                );
            return {
                createAnimation: (t, e = !0, n, i, s) => {
                    let a,
                        c,
                        u,
                        d = 0,
                        h = l;
                    const f = t.length;
                    if (e) {
                        h = et(t, i ? L.get(X(i)) : void 0);
                        if (((u = xt(t[f - 1])), f > 1 && null !== t[0])) c = xt(t[0]);
                        else {
                            const t = null == s ? void 0 : s.generator;
                            if (t) {
                                const { animation: e, generatorStartTime: n } = s,
                                    i = (null == e ? void 0 : e.startTime) || n || 0,
                                    r =
                                        (null == e ? void 0 : e.currentTime) ||
                                        performance.now() - i,
                                    o = t(r).current;
                                (c = o), (d = wt(e => t(e).current, r, o));
                            } else n && (c = xt(n()));
                        }
                    }
                    if (Tt(c) && Tt(u)) {
                        const t = r(c, u, d, null == i ? void 0 : i.includes('scale'));
                        (a = Object.assign(Object.assign({}, o(t, h)), { easing: 'linear' })),
                            s && ((s.generator = t), (s.generatorStartTime = performance.now()));
                    }
                    if (!a) {
                        a = { easing: 'ease', duration: o(r(0, 100)).overshootDuration };
                    }
                    return a;
                },
            };
        };
    })(
        ({
            stiffness: t = St,
            damping: e = Et,
            mass: n = Ot,
            from: i = 0,
            to: r = 1,
            velocity: o = 0,
            restSpeed: s,
            restDistance: a,
        } = {}) => {
            o = o ? g(o) : 0;
            const l = { done: !1, hasReachedTarget: !1, current: i, target: r },
                c = r - i,
                u = Math.sqrt(t / n) / 1e3,
                d = ((t = St, e = Et, n = Ot) => e / (2 * Math.sqrt(t * n)))(t, e, n),
                h = Math.abs(c) < 5;
            let f;
            if ((s || (s = h ? 0.01 : 2), a || (a = h ? 0.005 : 0.5), d < 1)) {
                const t = u * Math.sqrt(1 - d * d);
                f = e =>
                    r -
                    Math.exp(-d * u * e) *
                        (((d * u * c - o) / t) * Math.sin(t * e) + c * Math.cos(t * e));
            } else f = t => r - Math.exp(-u * t) * (c + (u * c - o) * t);
            return t => {
                l.current = f(t);
                const e = 0 === t ? o : wt(f, t, l.current),
                    n = Math.abs(e) <= s,
                    c = Math.abs(r - l.current) <= a;
                var u, d, h;
                return (
                    (l.done = n && c),
                    (l.hasReachedTarget =
                        ((u = i),
                        (d = r),
                        (h = l.current),
                        (u < d && h >= d) || (u > d && h <= d))),
                    l
                );
            };
        }
    ),
    At = { any: 0, all: 1 };
function It(t, e, { root: n, margin: i, amount: r = 'any' } = {}) {
    if ('undefined' == typeof IntersectionObserver) return () => {};
    const o = rt(t),
        s = new WeakMap(),
        a = new IntersectionObserver(
            t => {
                t.forEach(t => {
                    const n = s.get(t.target);
                    if (t.isIntersecting !== Boolean(n))
                        if (t.isIntersecting) {
                            const n = e(t);
                            m(n) ? s.set(t.target, n) : a.unobserve(t.target);
                        } else n && (n(t), s.delete(t.target));
                });
            },
            { root: n, rootMargin: i, threshold: 'number' == typeof r ? r : At[r] }
        );
    return o.forEach(t => a.observe(t)), () => a.disconnect();
}
const Nt = new WeakMap();
let Dt;
function Ft({ target: t, contentRect: e, borderBoxSize: n }) {
    var i;
    null === (i = Nt.get(t)) ||
        void 0 === i ||
        i.forEach(i => {
            i({
                target: t,
                contentSize: e,
                get size() {
                    return (function (t, e) {
                        if (e) {
                            const { inlineSize: t, blockSize: n } = e[0];
                            return { width: t, height: n };
                        }
                        return t instanceof SVGElement && 'getBBox' in t
                            ? t.getBBox()
                            : { width: t.offsetWidth, height: t.offsetHeight };
                    })(t, n);
                },
            });
        });
}
function kt(t) {
    t.forEach(Ft);
}
function _t(t, e) {
    Dt || ('undefined' != typeof ResizeObserver && (Dt = new ResizeObserver(kt)));
    const n = rt(t);
    return (
        n.forEach(t => {
            let n = Nt.get(t);
            n || ((n = new Set()), Nt.set(t, n)), n.add(e), null == Dt || Dt.observe(t);
        }),
        () => {
            n.forEach(t => {
                const n = Nt.get(t);
                null == n || n.delete(e),
                    (null == n ? void 0 : n.size) || null == Dt || Dt.unobserve(t);
            });
        }
    );
}
const Lt = new Set();
let Mt;
function Ct(t) {
    return (
        Lt.add(t),
        Mt ||
            ((Mt = () => {
                const t = { width: window.innerWidth, height: window.innerHeight },
                    e = { target: window, size: t, contentSize: t };
                Lt.forEach(t => t(e));
            }),
            window.addEventListener('resize', Mt)),
        () => {
            Lt.delete(t), !Lt.size && Mt && (Mt = void 0);
        }
    );
}
const Rt = { x: { length: 'Width', position: 'Left' }, y: { length: 'Height', position: 'Top' } };
function zt(t, e, n, i) {
    const r = n[e],
        { length: o, position: s } = Rt[e],
        a = r.current,
        l = n.time;
    (r.current = t[`scroll${s}`]),
        (r.scrollLength = t[`scroll${o}`] - t[`client${o}`]),
        (r.offset.length = 0),
        (r.offset[0] = 0),
        (r.offset[1] = r.scrollLength),
        (r.progress = c(0, r.scrollLength, r.current));
    const u = i - l;
    r.velocity = u > 50 ? 0 : b(r.current - a, u);
}
const jt = {
        All: [
            [0, 0],
            [1, 1],
        ],
    },
    Gt = { start: 0, center: 0.5, end: 1 };
function Wt(t, e, n = 0) {
    let r = 0;
    if ((void 0 !== Gt[t] && (t = Gt[t]), v(t))) {
        const e = parseFloat(t);
        t.endsWith('px')
            ? (r = e)
            : t.endsWith('%')
              ? (t = e / 100)
              : t.endsWith('vw')
                ? (r = (e / 100) * document.documentElement.clientWidth)
                : t.endsWith('vh')
                  ? (r = (e / 100) * document.documentElement.clientHeight)
                  : (t = e);
    }
    return i(t) && (r = e * t), n + r;
}
const Bt = [0, 0];
function $t(t, e, n, r) {
    let o = Array.isArray(t) ? t : Bt,
        s = 0,
        a = 0;
    return (
        i(t)
            ? (o = [t, t])
            : v(t) && (o = (t = t.trim()).includes(' ') ? t.split(' ') : [t, Gt[t] ? t : '0']),
        (s = Wt(o[0], n, r)),
        (a = Wt(o[1], e)),
        s - a
    );
}
const qt = { x: 0, y: 0 };
function Ut(t, e, n) {
    let { offset: i = jt.All } = n;
    const { target: r = t, axis: o = 'y' } = n,
        s = 'y' === o ? 'height' : 'width',
        a =
            r !== t
                ? (function (t, e) {
                      let n = { x: 0, y: 0 },
                          i = t;
                      for (; i && i !== e; )
                          if (i instanceof HTMLElement)
                              (n.x += i.offsetLeft), (n.y += i.offsetTop), (i = i.offsetParent);
                          else if (i instanceof SVGGraphicsElement && 'getBBox' in i) {
                              const { top: t, left: e } = i.getBBox();
                              for (n.x += e, n.y += t; i && 'svg' !== i.tagName; ) i = i.parentNode;
                          }
                      return n;
                  })(r, t)
                : qt,
        l =
            r === t
                ? { width: t.scrollWidth, height: t.scrollHeight }
                : { width: r.clientWidth, height: r.clientHeight },
        c = { width: t.clientWidth, height: t.clientHeight };
    e[o].offset.length = 0;
    let u = !e[o].interpolate;
    const f = i.length;
    for (let d = 0; d < f; d++) {
        const t = $t(i[d], c[s], l[s], a[o]);
        u || t === e[o].interpolatorOffsets[d] || (u = !0), (e[o].offset[d] = t);
    }
    u && ((e[o].interpolate = h(d(f), e[o].offset)), (e[o].interpolatorOffsets = [...e[o].offset])),
        (e[o].progress = e[o].interpolate(e[o].current));
}
function Ht(t, e, n, i = {}) {
    const r = i.axis || 'y';
    return {
        measure: () =>
            (function (t, e = t, n) {
                if (((n.x.targetOffset = 0), (n.y.targetOffset = 0), e !== t)) {
                    let i = e;
                    for (; i && i != t; )
                        (n.x.targetOffset += i.offsetLeft),
                            (n.y.targetOffset += i.offsetTop),
                            (i = i.offsetParent);
                }
                (n.x.targetLength = e === t ? e.scrollWidth : e.clientWidth),
                    (n.y.targetLength = e === t ? e.scrollHeight : e.clientHeight),
                    (n.x.containerLength = t.clientWidth),
                    (n.y.containerLength = t.clientHeight);
            })(t, i.target, n),
        update: e => {
            !(function (t, e, n) {
                zt(t, 'x', e, n), zt(t, 'y', e, n), (e.time = n);
            })(t, n, e),
                (i.offset || i.target) && Ut(t, n, i);
        },
        notify: m(e) ? () => e(n) : Vt(e, n[r]),
    };
}
function Vt(t, e) {
    return (
        t.pause(),
        t.forEachNative((t, { easing: e }) => {
            var n, i;
            if (t.updateDuration) e || (t.easing = l), t.updateDuration(1);
            else {
                const r = { duration: 1e3 };
                e || (r.easing = 'linear'),
                    null ===
                        (i = null === (n = t.effect) || void 0 === n ? void 0 : n.updateTiming) ||
                        void 0 === i ||
                        i.call(n, r);
            }
        }),
        () => {
            t.currentTime = e.progress;
        }
    );
}
const Kt = new WeakMap(),
    Zt = new WeakMap(),
    Yt = new WeakMap(),
    Xt = t => (t === document.documentElement ? window : t);
function Jt(t, e = {}) {
    var { container: n = document.documentElement } = e,
        i = ft(e, ['container']);
    let r = Yt.get(n);
    r || ((r = new Set()), Yt.set(n, r));
    const o = Ht(
        n,
        t,
        {
            time: 0,
            x: {
                current: 0,
                offset: [],
                progress: 0,
                scrollLength: 0,
                targetOffset: 0,
                targetLength: 0,
                containerLength: 0,
                velocity: 0,
            },
            y: {
                current: 0,
                offset: [],
                progress: 0,
                scrollLength: 0,
                targetOffset: 0,
                targetLength: 0,
                containerLength: 0,
                velocity: 0,
            },
        },
        i
    );
    if ((r.add(o), !Kt.has(n))) {
        const t = () => {
            const t = performance.now();
            for (const e of r) e.measure();
            for (const e of r) e.update(t);
            for (const e of r) e.notify();
        };
        Kt.set(n, t);
        const e = Xt(n);
        window.addEventListener('resize', t, { passive: !0 }),
            n !== document.documentElement && Zt.set(n, ((a = t), m((s = n)) ? Ct(s) : _t(s, a))),
            e.addEventListener('scroll', t, { passive: !0 });
    }
    var s, a;
    const l = Kt.get(n),
        c = requestAnimationFrame(l);
    return () => {
        var e;
        'function' != typeof t && t.stop(), cancelAnimationFrame(c);
        const i = Yt.get(n);
        if (!i) return;
        if ((i.delete(o), i.size)) return;
        const r = Kt.get(n);
        Kt.delete(n),
            r &&
                (Xt(n).removeEventListener('scroll', r),
                null === (e = Zt.get(n)) || void 0 === e || e(),
                window.removeEventListener('resize', r));
    };
}
function Qt(t, e = {}) {
    return st(
        [
            () => {
                const n = new x(t, [0, 1], e);
                return n.finished.catch(() => {}), n;
            },
        ],
        e,
        e.duration
    );
}
function te(t, e, n) {
    return (m(t) ? Qt : dt)(t, e, n);
}
const ee = [
        'setup',
        'read',
        'resolveKeyframes',
        'preUpdate',
        'update',
        'preRender',
        'render',
        'postRender',
    ],
    ne = 1e3 / 60;
const ie = 'undefined' != typeof requestAnimationFrame ? requestAnimationFrame : () => {},
    { schedule: re } = (function (t, e) {
        let n = !1,
            i = !0;
        const r = { delta: 0, timestamp: 0, isProcessing: !1 },
            o = ee.reduce(
                (t, e) => (
                    (t[e] = (function () {
                        let t = new Set(),
                            e = new Set();
                        const n = new Set();
                        let i = !1,
                            r = !1;
                        const o = {
                            schedule(r, o = !1, s = !1) {
                                const a = s && i ? t : e;
                                return o && n.add(r), a.has(r) || a.add(r), r;
                            },
                            cancel(t) {
                                e.delete(t), n.delete(t);
                            },
                            process(s) {
                                i
                                    ? (r = !0)
                                    : ((i = !0),
                                      ([t, e] = [e, t]),
                                      t.forEach(t => {
                                          t(s), n.has(t) || e.delete(t);
                                      }),
                                      t.clear(),
                                      (i = !1),
                                      r && ((r = !1), o.process(s)));
                            },
                        };
                        return o;
                    })()),
                    t
                ),
                {}
            ),
            s = () => {
                const a = performance.now();
                (n = !1),
                    (r.delta = i ? ne : Math.max(Math.min(a - r.timestamp, 40), 1)),
                    (r.timestamp = a),
                    (r.isProcessing = !0);
                for (const t of ee) o[t].process(r);
                (r.isProcessing = !1), n && e && ((i = !1), t(s));
            };
        return {
            schedule: ee.reduce((e, a) => {
                const l = o[a];
                return (
                    (e[a] = (e, o = !1, a = !1) => (
                        n || ((n = !0), (i = !0), r.isProcessing || t(s)), l.schedule(e, o, a)
                    )),
                    e
                );
            }, {}),
            cancel: t => {
                ee.forEach(e => {
                    o[e].cancel(t);
                });
            },
            state: r,
            steps: o,
        };
    })(ie, !0);
var oe = [
        'input:not([inert]):not([inert] *)',
        'select:not([inert]):not([inert] *)',
        'textarea:not([inert]):not([inert] *)',
        'a[href]:not([inert]):not([inert] *)',
        'button:not([inert]):not([inert] *)',
        '[tabindex]:not(slot):not([inert]):not([inert] *)',
        'audio[controls]:not([inert]):not([inert] *)',
        'video[controls]:not([inert]):not([inert] *)',
        '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
        'details>summary:first-of-type:not([inert]):not([inert] *)',
        'details:not([inert]):not([inert] *)',
    ],
    se = oe.join(','),
    ae = 'undefined' == typeof Element,
    le = ae
        ? function () {}
        : Element.prototype.matches ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector,
    ce =
        !ae && Element.prototype.getRootNode
            ? function (t) {
                  var e;
                  return null == t || null === (e = t.getRootNode) || void 0 === e
                      ? void 0
                      : e.call(t);
              }
            : function (t) {
                  return null == t ? void 0 : t.ownerDocument;
              },
    ue = function (t, e) {
        var n;
        void 0 === e && (e = !0);
        var i =
            null == t || null === (n = t.getAttribute) || void 0 === n
                ? void 0
                : n.call(t, 'inert');
        return (
            '' === i ||
            'true' === i ||
            (e && t && ('function' == typeof t.closest ? t.closest('[inert]') : ue(t.parentNode)))
        );
    },
    de = function (t, e, n) {
        if (ue(t)) return [];
        var i = Array.prototype.slice.apply(t.querySelectorAll(se));
        return e && le.call(t, se) && i.unshift(t), (i = i.filter(n));
    },
    he = function (t, e, n) {
        for (var i = [], r = Array.from(t); r.length; ) {
            var o = r.shift();
            if (!ue(o, !1))
                if ('SLOT' === o.tagName) {
                    var s = o.assignedElements(),
                        a = s.length ? s : o.children,
                        l = he(a, !0, n);
                    n.flatten ? i.push.apply(i, l) : i.push({ scopeParent: o, candidates: l });
                } else {
                    le.call(o, se) && n.filter(o) && (e || !t.includes(o)) && i.push(o);
                    var c =
                            o.shadowRoot ||
                            ('function' == typeof n.getShadowRoot && n.getShadowRoot(o)),
                        u = !ue(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(o));
                    if (c && u) {
                        var d = he(!0 === c ? o.children : c.children, !0, n);
                        n.flatten ? i.push.apply(i, d) : i.push({ scopeParent: o, candidates: d });
                    } else r.unshift.apply(r, o.children);
                }
        }
        return i;
    },
    fe = function (t) {
        return !isNaN(parseInt(t.getAttribute('tabindex'), 10));
    },
    pe = function (t) {
        if (!t) throw new Error('No node provided');
        return t.tabIndex < 0 &&
            (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) ||
                (function (t) {
                    var e,
                        n =
                            null == t || null === (e = t.getAttribute) || void 0 === e
                                ? void 0
                                : e.call(t, 'contenteditable');
                    return '' === n || 'true' === n;
                })(t)) &&
            !fe(t)
            ? 0
            : t.tabIndex;
    },
    me = function (t, e) {
        return t.tabIndex === e.tabIndex
            ? t.documentOrder - e.documentOrder
            : t.tabIndex - e.tabIndex;
    },
    ve = function (t) {
        return 'INPUT' === t.tagName;
    },
    ye = function (t) {
        return (
            (function (t) {
                return ve(t) && 'radio' === t.type;
            })(t) &&
            !(function (t) {
                if (!t.name) return !0;
                var e,
                    n = t.form || ce(t),
                    i = function (t) {
                        return n.querySelectorAll('input[type="radio"][name="' + t + '"]');
                    };
                if (
                    'undefined' != typeof window &&
                    void 0 !== window.CSS &&
                    'function' == typeof window.CSS.escape
                )
                    e = i(window.CSS.escape(t.name));
                else
                    try {
                        e = i(t.name);
                    } catch (o) {
                        return (
                            console.error(
                                'Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s',
                                o.message
                            ),
                            !1
                        );
                    }
                var r = (function (t, e) {
                    for (var n = 0; n < t.length; n++)
                        if (t[n].checked && t[n].form === e) return t[n];
                })(e, t.form);
                return !r || r === t;
            })(t)
        );
    },
    ge = function (t) {
        var e = t.getBoundingClientRect(),
            n = e.width,
            i = e.height;
        return 0 === n && 0 === i;
    },
    be = function (t, e) {
        var n = e.displayCheck,
            i = e.getShadowRoot;
        if ('full-native' === n && 'checkVisibility' in t)
            return !t.checkVisibility({
                checkOpacity: !1,
                opacityProperty: !1,
                contentVisibilityAuto: !0,
                visibilityProperty: !0,
                checkVisibilityCSS: !0,
            });
        if ('hidden' === getComputedStyle(t).visibility) return !0;
        var r = le.call(t, 'details>summary:first-of-type') ? t.parentElement : t;
        if (le.call(r, 'details:not([open]) *')) return !0;
        if (n && 'full' !== n && 'full-native' !== n && 'legacy-full' !== n) {
            if ('non-zero-area' === n) return ge(t);
        } else {
            if ('function' == typeof i) {
                for (var o = t; t; ) {
                    var s = t.parentElement,
                        a = ce(t);
                    if (s && !s.shadowRoot && !0 === i(s)) return ge(t);
                    t = t.assignedSlot ? t.assignedSlot : s || a === t.ownerDocument ? s : a.host;
                }
                t = o;
            }
            if (
                (function (t) {
                    var e,
                        n,
                        i,
                        r,
                        o = t && ce(t),
                        s = null === (e = o) || void 0 === e ? void 0 : e.host,
                        a = !1;
                    if (o && o !== t)
                        for (
                            a = !!(
                                (null !== (n = s) &&
                                    void 0 !== n &&
                                    null !== (i = n.ownerDocument) &&
                                    void 0 !== i &&
                                    i.contains(s)) ||
                                (null != t &&
                                    null !== (r = t.ownerDocument) &&
                                    void 0 !== r &&
                                    r.contains(t))
                            );
                            !a && s;

                        ) {
                            var l, c, u;
                            a = !(
                                null ===
                                    (c = s =
                                        null === (l = o = ce(s)) || void 0 === l
                                            ? void 0
                                            : l.host) ||
                                void 0 === c ||
                                null === (u = c.ownerDocument) ||
                                void 0 === u ||
                                !u.contains(s)
                            );
                        }
                    return a;
                })(t)
            )
                return !t.getClientRects().length;
            if ('legacy-full' !== n) return !0;
        }
        return !1;
    },
    we = function (t, e) {
        return !(
            e.disabled ||
            (function (t) {
                return ve(t) && 'hidden' === t.type;
            })(e) ||
            be(e, t) ||
            (function (t) {
                return (
                    'DETAILS' === t.tagName &&
                    Array.prototype.slice.apply(t.children).some(function (t) {
                        return 'SUMMARY' === t.tagName;
                    })
                );
            })(e) ||
            (function (t) {
                if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
                    for (var e = t.parentElement; e; ) {
                        if ('FIELDSET' === e.tagName && e.disabled) {
                            for (var n = 0; n < e.children.length; n++) {
                                var i = e.children.item(n);
                                if ('LEGEND' === i.tagName)
                                    return !!le.call(e, 'fieldset[disabled] *') || !i.contains(t);
                            }
                            return !0;
                        }
                        e = e.parentElement;
                    }
                return !1;
            })(e)
        );
    },
    Se = function (t, e) {
        return !(ye(e) || pe(e) < 0 || !we(t, e));
    },
    Ee = function (t) {
        var e = parseInt(t.getAttribute('tabindex'), 10);
        return !!(isNaN(e) || e >= 0);
    },
    Oe = function (t) {
        var e = [],
            n = [];
        return (
            t.forEach(function (t, i) {
                var r = !!t.scopeParent,
                    o = r ? t.scopeParent : t,
                    s = (function (t, e) {
                        var n = pe(t);
                        return n < 0 && e && !fe(t) ? 0 : n;
                    })(o, r),
                    a = r ? Oe(t.candidates) : o;
                0 === s
                    ? r
                        ? e.push.apply(e, a)
                        : e.push(o)
                    : n.push({ documentOrder: i, tabIndex: s, item: t, isScope: r, content: a });
            }),
            n
                .sort(me)
                .reduce(function (t, e) {
                    return e.isScope ? t.push.apply(t, e.content) : t.push(e.content), t;
                }, [])
                .concat(e)
        );
    },
    Te = function (t, e) {
        if (((e = e || {}), !t)) throw new Error('No node provided');
        return !1 !== le.call(t, se) && Se(e, t);
    },
    xe = oe.concat('iframe:not([inert]):not([inert] *)').join(','),
    Pe = function (t, e) {
        if (((e = e || {}), !t)) throw new Error('No node provided');
        return !1 !== le.call(t, xe) && we(e, t);
    };
function Ae(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var n = 0, i = Array(e); n < e; n++) i[n] = t[n];
    return i;
}
function Ie(t, e, n, i, r, o, s) {
    try {
        var a = t[o](s),
            l = a.value;
    } catch (c) {
        return void n(c);
    }
    a.done ? e(l) : Promise.resolve(l).then(i, r);
}
function Ne(t) {
    return function () {
        var e = this,
            n = arguments;
        return new Promise(function (i, r) {
            var o = t.apply(e, n);
            function s(t) {
                Ie(o, i, r, s, a, 'next', t);
            }
            function a(t) {
                Ie(o, i, r, s, a, 'throw', t);
            }
            s(void 0);
        });
    };
}
function De(t, e) {
    var n = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
    if (!n) {
        if (Array.isArray(t) || (n = Re(t)) || e) {
            n && (t = n);
            var i = 0,
                r = function () {};
            return {
                s: r,
                n: function () {
                    return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
                },
                e: function (t) {
                    throw t;
                },
                f: r,
            };
        }
        throw new TypeError(
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
        );
    }
    var o,
        s = !0,
        a = !1;
    return {
        s: function () {
            n = n.call(t);
        },
        n: function () {
            var t = n.next();
            return (s = t.done), t;
        },
        e: function (t) {
            (a = !0), (o = t);
        },
        f: function () {
            try {
                s || null == n.return || n.return();
            } finally {
                if (a) throw o;
            }
        },
    };
}
function Fe(t, e, n) {
    return (
        (e = (function (t) {
            var e = (function (t, e) {
                if ('object' != typeof t || !t) return t;
                var n = t[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var i = n.call(t, e);
                    if ('object' != typeof i) return i;
                    throw new TypeError('@@toPrimitive must return a primitive value.');
                }
                return ('string' === e ? String : Number)(t);
            })(t, 'string');
            return 'symbol' == typeof e ? e : e + '';
        })(e)) in t
            ? Object.defineProperty(t, e, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
              })
            : (t[e] = n),
        t
    );
}
function ke(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        e &&
            (i = i.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, i);
    }
    return n;
}
function _e(t) {
    for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2
            ? ke(Object(n), !0).forEach(function (e) {
                  Fe(t, e, n[e]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
              : ke(Object(n)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                });
    }
    return t;
}
function Le() {
    var t,
        e,
        n = 'function' == typeof Symbol ? Symbol : {},
        i = n.iterator || '@@iterator',
        r = n.toStringTag || '@@toStringTag';
    function o(n, i, r, o) {
        var l = i && i.prototype instanceof a ? i : a,
            c = Object.create(l.prototype);
        return (
            Me(
                c,
                '_invoke',
                (function (n, i, r) {
                    var o,
                        a,
                        l,
                        c = 0,
                        u = r || [],
                        d = !1,
                        h = {
                            p: 0,
                            n: 0,
                            v: t,
                            a: f,
                            f: f.bind(t, 4),
                            d: function (e, n) {
                                return (o = e), (a = 0), (l = t), (h.n = n), s;
                            },
                        };
                    function f(n, i) {
                        for (a = n, l = i, e = 0; !d && c && !r && e < u.length; e++) {
                            var r,
                                o = u[e],
                                f = h.p,
                                p = o[2];
                            n > 3
                                ? (r = p === i) &&
                                  ((l = o[(a = o[4]) ? 5 : ((a = 3), 3)]), (o[4] = o[5] = t))
                                : o[0] <= f &&
                                  ((r = n < 2 && f < o[1])
                                      ? ((a = 0), (h.v = i), (h.n = o[1]))
                                      : f < p &&
                                        (r = n < 3 || o[0] > i || i > p) &&
                                        ((o[4] = n), (o[5] = i), (h.n = p), (a = 0)));
                        }
                        if (r || n > 1) return s;
                        throw ((d = !0), i);
                    }
                    return function (r, u, p) {
                        if (c > 1) throw TypeError('Generator is already running');
                        for (d && 1 === u && f(u, p), a = u, l = p; (e = a < 2 ? t : l) || !d; ) {
                            o ||
                                (a
                                    ? a < 3
                                        ? (a > 1 && (h.n = -1), f(a, l))
                                        : (h.n = l)
                                    : (h.v = l));
                            try {
                                if (((c = 2), o)) {
                                    if ((a || (r = 'next'), (e = o[r]))) {
                                        if (!(e = e.call(o, l)))
                                            throw TypeError('iterator result is not an object');
                                        if (!e.done) return e;
                                        (l = e.value), a < 2 && (a = 0);
                                    } else
                                        1 === a && (e = o.return) && e.call(o),
                                            a < 2 &&
                                                ((l = TypeError(
                                                    "The iterator does not provide a '" +
                                                        r +
                                                        "' method"
                                                )),
                                                (a = 1));
                                    o = t;
                                } else if ((e = (d = h.n < 0) ? l : n.call(i, h)) !== s) break;
                            } catch (m) {
                                (o = t), (a = 1), (l = m);
                            } finally {
                                c = 1;
                            }
                        }
                        return { value: e, done: d };
                    };
                })(n, r, o),
                !0
            ),
            c
        );
    }
    var s = {};
    function a() {}
    function l() {}
    function c() {}
    e = Object.getPrototypeOf;
    var u = [][i]
            ? e(e([][i]()))
            : (Me((e = {}), i, function () {
                  return this;
              }),
              e),
        d = (c.prototype = a.prototype = Object.create(u));
    function h(t) {
        return (
            Object.setPrototypeOf
                ? Object.setPrototypeOf(t, c)
                : ((t.__proto__ = c), Me(t, r, 'GeneratorFunction')),
            (t.prototype = Object.create(d)),
            t
        );
    }
    return (
        (l.prototype = c),
        Me(d, 'constructor', c),
        Me(c, 'constructor', l),
        (l.displayName = 'GeneratorFunction'),
        Me(c, r, 'GeneratorFunction'),
        Me(d),
        Me(d, r, 'Generator'),
        Me(d, i, function () {
            return this;
        }),
        Me(d, 'toString', function () {
            return '[object Generator]';
        }),
        (Le = function () {
            return { w: o, m: h };
        })()
    );
}
function Me(t, e, n, i) {
    var r = Object.defineProperty;
    try {
        r({}, '', {});
    } catch (o) {
        r = 0;
    }
    (Me = function (t, e, n, i) {
        function o(e, n) {
            Me(t, e, function (t) {
                return this._invoke(e, n, t);
            });
        }
        e
            ? r
                ? r(t, e, { value: n, enumerable: !i, configurable: !i, writable: !i })
                : (t[e] = n)
            : (o('next', 0), o('throw', 1), o('return', 2));
    })(t, e, n, i);
}
function Ce(t) {
    return (
        (function (t) {
            if (Array.isArray(t)) return Ae(t);
        })(t) ||
        (function (t) {
            if (
                ('undefined' != typeof Symbol && null != t[Symbol.iterator]) ||
                null != t['@@iterator']
            )
                return Array.from(t);
        })(t) ||
        Re(t) ||
        (function () {
            throw new TypeError(
                'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
        })()
    );
}
function Re(t, e) {
    if (t) {
        if ('string' == typeof t) return Ae(t, e);
        var n = {}.toString.call(t).slice(8, -1);
        return (
            'Object' === n && t.constructor && (n = t.constructor.name),
            'Map' === n || 'Set' === n
                ? Array.from(t)
                : 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                  ? Ae(t, e)
                  : void 0
        );
    }
}
var ze = {
        getActiveTrap: function (t) {
            return (null == t ? void 0 : t.length) > 0 ? t[t.length - 1] : null;
        },
        activateTrap: function (t, e) {
            e !== ze.getActiveTrap(t) && ze.pauseTrap(t);
            var n = t.indexOf(e);
            -1 === n || t.splice(n, 1), t.push(e);
        },
        deactivateTrap: function (t, e) {
            var n = t.indexOf(e);
            -1 !== n && t.splice(n, 1), ze.unpauseTrap(t);
        },
        pauseTrap: function (t) {
            var e = ze.getActiveTrap(t);
            null == e || e._setPausedState(!0);
        },
        unpauseTrap: function (t) {
            var e = ze.getActiveTrap(t);
            e && !e._isManuallyPaused() && e._setPausedState(!1);
        },
    },
    je = function (t) {
        return 'Tab' === (null == t ? void 0 : t.key) || 9 === (null == t ? void 0 : t.keyCode);
    },
    Ge = function (t) {
        return je(t) && !t.shiftKey;
    },
    We = function (t) {
        return je(t) && t.shiftKey;
    },
    Be = function (t) {
        return setTimeout(t, 0);
    },
    $e = function (t) {
        for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
            n[i - 1] = arguments[i];
        return 'function' == typeof t ? t.apply(void 0, n) : t;
    },
    qe = function (t) {
        return t.target.shadowRoot && 'function' == typeof t.composedPath
            ? t.composedPath()[0]
            : t.target;
    },
    Ue = [],
    He = function (t, e) {
        var n,
            i = (null == e ? void 0 : e.document) || document,
            r = (null == e ? void 0 : e.trapStack) || Ue,
            o = _e(
                {
                    returnFocusOnDeactivate: !0,
                    escapeDeactivates: !0,
                    delayInitialFocus: !0,
                    isolateSubtrees: !1,
                    isKeyForward: Ge,
                    isKeyBackward: We,
                },
                e
            ),
            s = {
                containers: [],
                containerGroups: [],
                tabbableGroups: [],
                adjacentElements: new Set(),
                alreadySilent: new Set(),
                nodeFocusedBeforeActivation: null,
                mostRecentlyFocusedNode: null,
                active: !1,
                paused: !1,
                manuallyPaused: !1,
                delayInitialFocusTimer: void 0,
                recentNavEvent: void 0,
            },
            a = function (t, e, n) {
                return t && void 0 !== t[e] ? t[e] : o[n || e];
            },
            l = function (t, e) {
                var n =
                    'function' == typeof (null == e ? void 0 : e.composedPath)
                        ? e.composedPath()
                        : void 0;
                return s.containerGroups.findIndex(function (e) {
                    var i = e.container,
                        r = e.tabbableNodes;
                    return (
                        i.contains(t) ||
                        (null == n ? void 0 : n.includes(i)) ||
                        r.find(function (e) {
                            return e === t;
                        })
                    );
                });
            },
            c = function (t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    n = e.hasFallback,
                    r = void 0 !== n && n,
                    s = e.params,
                    a = void 0 === s ? [] : s,
                    l = o[t];
                if (
                    ('function' == typeof l && (l = l.apply(void 0, Ce(a))),
                    !0 === l && (l = void 0),
                    !l)
                ) {
                    if (void 0 === l || !1 === l) return l;
                    throw new Error(
                        '`'.concat(
                            t,
                            '` was specified but was not a node, or did not return a node'
                        )
                    );
                }
                var c = l;
                if ('string' == typeof l) {
                    try {
                        c = i.querySelector(l);
                    } catch (u) {
                        throw new Error(
                            '`'
                                .concat(t, '` appears to be an invalid selector; error="')
                                .concat(u.message, '"')
                        );
                    }
                    if (!c && !r)
                        throw new Error('`'.concat(t, '` as selector refers to no known node'));
                }
                return c;
            },
            u = function () {
                var t = c('initialFocus', { hasFallback: !0 });
                if (!1 === t) return !1;
                if (void 0 === t || (t && !Pe(t, o.tabbableOptions)))
                    if (l(i.activeElement) >= 0) t = i.activeElement;
                    else {
                        var e = s.tabbableGroups[0];
                        t = (e && e.firstTabbableNode) || c('fallbackFocus');
                    }
                else null === t && (t = c('fallbackFocus'));
                if (!t)
                    throw new Error('Your focus-trap needs to have at least one focusable element');
                return t;
            },
            d = function () {
                if (
                    ((s.containerGroups = s.containers.map(function (t) {
                        var e = (function (t, e) {
                                var n;
                                return (
                                    (n = (e = e || {}).getShadowRoot
                                        ? he([t], e.includeContainer, {
                                              filter: Se.bind(null, e),
                                              flatten: !1,
                                              getShadowRoot: e.getShadowRoot,
                                              shadowRootFilter: Ee,
                                          })
                                        : de(t, e.includeContainer, Se.bind(null, e))),
                                    Oe(n)
                                );
                            })(t, o.tabbableOptions),
                            n = (function (t, e) {
                                return (e = e || {}).getShadowRoot
                                    ? he([t], e.includeContainer, {
                                          filter: we.bind(null, e),
                                          flatten: !0,
                                          getShadowRoot: e.getShadowRoot,
                                      })
                                    : de(t, e.includeContainer, we.bind(null, e));
                            })(t, o.tabbableOptions),
                            i = e.length > 0 ? e[0] : void 0,
                            r = e.length > 0 ? e[e.length - 1] : void 0,
                            s = n.find(function (t) {
                                return Te(t);
                            }),
                            a = n
                                .slice()
                                .reverse()
                                .find(function (t) {
                                    return Te(t);
                                }),
                            l = !!e.find(function (t) {
                                return pe(t) > 0;
                            });
                        return {
                            container: t,
                            tabbableNodes: e,
                            focusableNodes: n,
                            posTabIndexesFound: l,
                            firstTabbableNode: i,
                            lastTabbableNode: r,
                            firstDomTabbableNode: s,
                            lastDomTabbableNode: a,
                            nextTabbableNode: function (t) {
                                var i =
                                        !(arguments.length > 1 && void 0 !== arguments[1]) ||
                                        arguments[1],
                                    r = e.indexOf(t);
                                return r < 0
                                    ? i
                                        ? n.slice(n.indexOf(t) + 1).find(function (t) {
                                              return Te(t);
                                          })
                                        : n
                                              .slice(0, n.indexOf(t))
                                              .reverse()
                                              .find(function (t) {
                                                  return Te(t);
                                              })
                                    : e[r + (i ? 1 : -1)];
                            },
                        };
                    })),
                    (s.tabbableGroups = s.containerGroups.filter(function (t) {
                        return t.tabbableNodes.length > 0;
                    })),
                    s.tabbableGroups.length <= 0 && !c('fallbackFocus'))
                )
                    throw new Error(
                        'Your focus-trap must have at least one container with at least one tabbable node in it at all times'
                    );
                if (
                    s.containerGroups.find(function (t) {
                        return t.posTabIndexesFound;
                    }) &&
                    s.containerGroups.length > 1
                )
                    throw new Error(
                        "At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps."
                    );
            },
            h = function (t) {
                var e = t.activeElement;
                if (e)
                    return e.shadowRoot && null !== e.shadowRoot.activeElement
                        ? h(e.shadowRoot)
                        : e;
            },
            f = function (t) {
                !1 !== t &&
                    t !== h(document) &&
                    (t && t.focus
                        ? (t.focus({ preventScroll: !!o.preventScroll }),
                          (s.mostRecentlyFocusedNode = t),
                          (function (t) {
                              return (
                                  t.tagName &&
                                  'input' === t.tagName.toLowerCase() &&
                                  'function' == typeof t.select
                              );
                          })(t) && t.select())
                        : f(u()));
            },
            p = function (t) {
                var e = c('setReturnFocus', { params: [t] });
                return e || (!1 !== e && t);
            },
            m = function (t) {
                var e = t.target,
                    n = t.event,
                    i = t.isBackward,
                    r = void 0 !== i && i;
                (e = e || qe(n)), d();
                var a = null;
                if (s.tabbableGroups.length > 0) {
                    var u = l(e, n),
                        h = u >= 0 ? s.containerGroups[u] : void 0;
                    if (u < 0)
                        a = r
                            ? s.tabbableGroups[s.tabbableGroups.length - 1].lastTabbableNode
                            : s.tabbableGroups[0].firstTabbableNode;
                    else if (r) {
                        var f = s.tabbableGroups.findIndex(function (t) {
                            var n = t.firstTabbableNode;
                            return e === n;
                        });
                        if (
                            (f < 0 &&
                                (h.container === e ||
                                    (Pe(e, o.tabbableOptions) &&
                                        !Te(e, o.tabbableOptions) &&
                                        !h.nextTabbableNode(e, !1))) &&
                                (f = u),
                            f >= 0)
                        ) {
                            var p = 0 === f ? s.tabbableGroups.length - 1 : f - 1,
                                m = s.tabbableGroups[p];
                            a = pe(e) >= 0 ? m.lastTabbableNode : m.lastDomTabbableNode;
                        } else je(n) || (a = h.nextTabbableNode(e, !1));
                    } else {
                        var v = s.tabbableGroups.findIndex(function (t) {
                            var n = t.lastTabbableNode;
                            return e === n;
                        });
                        if (
                            (v < 0 &&
                                (h.container === e ||
                                    (Pe(e, o.tabbableOptions) &&
                                        !Te(e, o.tabbableOptions) &&
                                        !h.nextTabbableNode(e))) &&
                                (v = u),
                            v >= 0)
                        ) {
                            var y = v === s.tabbableGroups.length - 1 ? 0 : v + 1,
                                g = s.tabbableGroups[y];
                            a = pe(e) >= 0 ? g.firstTabbableNode : g.firstDomTabbableNode;
                        } else je(n) || (a = h.nextTabbableNode(e));
                    }
                } else a = c('fallbackFocus');
                return a;
            },
            v = function (t) {
                var e = qe(t);
                l(e, t) >= 0 ||
                    ($e(o.clickOutsideDeactivates, t)
                        ? n.deactivate({ returnFocus: o.returnFocusOnDeactivate })
                        : $e(o.allowOutsideClick, t) || t.preventDefault());
            },
            y = function (t) {
                var e = qe(t),
                    n = l(e, t) >= 0;
                if (n || e instanceof Document) n && (s.mostRecentlyFocusedNode = e);
                else {
                    var i;
                    t.stopImmediatePropagation();
                    var r = !0;
                    if (s.mostRecentlyFocusedNode)
                        if (pe(s.mostRecentlyFocusedNode) > 0) {
                            var a = l(s.mostRecentlyFocusedNode),
                                c = s.containerGroups[a].tabbableNodes;
                            if (c.length > 0) {
                                var d = c.findIndex(function (t) {
                                    return t === s.mostRecentlyFocusedNode;
                                });
                                d >= 0 &&
                                    (o.isKeyForward(s.recentNavEvent)
                                        ? d + 1 < c.length && ((i = c[d + 1]), (r = !1))
                                        : d - 1 >= 0 && ((i = c[d - 1]), (r = !1)));
                            }
                        } else
                            s.containerGroups.some(function (t) {
                                return t.tabbableNodes.some(function (t) {
                                    return pe(t) > 0;
                                });
                            }) || (r = !1);
                    else r = !1;
                    r &&
                        (i = m({
                            target: s.mostRecentlyFocusedNode,
                            isBackward: o.isKeyBackward(s.recentNavEvent),
                        })),
                        f(i || s.mostRecentlyFocusedNode || u());
                }
                s.recentNavEvent = void 0;
            },
            g = function (t) {
                (o.isKeyForward(t) || o.isKeyBackward(t)) &&
                    (function (t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        s.recentNavEvent = t;
                        var n = m({ event: t, isBackward: e });
                        n && (je(t) && t.preventDefault(), f(n));
                    })(t, o.isKeyBackward(t));
            },
            b = function (t) {
                var e;
                ('Escape' !== (null == (e = t) ? void 0 : e.key) &&
                    'Esc' !== (null == e ? void 0 : e.key) &&
                    27 !== (null == e ? void 0 : e.keyCode)) ||
                    !1 === $e(o.escapeDeactivates, t) ||
                    (t.preventDefault(), n.deactivate());
            },
            w = function (t) {
                var e = qe(t);
                l(e, t) >= 0 ||
                    $e(o.clickOutsideDeactivates, t) ||
                    $e(o.allowOutsideClick, t) ||
                    (t.preventDefault(), t.stopImmediatePropagation());
            },
            S = function () {
                return s.active
                    ? (ze.activateTrap(r, n),
                      o.delayInitialFocus
                          ? (t = new Promise(function (t) {
                                s.delayInitialFocusTimer = Be(function () {
                                    f(u()), t();
                                });
                            }))
                          : ((t = Promise.resolve()), f(u())),
                      i.addEventListener('focusin', y, !0),
                      i.addEventListener('mousedown', v, { capture: !0, passive: !1 }),
                      i.addEventListener('touchstart', v, { capture: !0, passive: !1 }),
                      i.addEventListener('click', w, { capture: !0, passive: !1 }),
                      i.addEventListener('keydown', g, { capture: !0, passive: !1 }),
                      i.addEventListener('keydown', b),
                      t)
                    : Promise.resolve();
                var t;
            },
            E = function () {
                if (s.active)
                    return (
                        i.removeEventListener('focusin', y, !0),
                        i.removeEventListener('mousedown', v, !0),
                        i.removeEventListener('touchstart', v, !0),
                        i.removeEventListener('click', w, !0),
                        i.removeEventListener('keydown', g, !0),
                        i.removeEventListener('keydown', b),
                        n
                    );
            },
            O =
                'undefined' != typeof window && 'MutationObserver' in window
                    ? new MutationObserver(function (t) {
                          t.some(function (t) {
                              return Array.from(t.removedNodes).some(function (t) {
                                  return t === s.mostRecentlyFocusedNode;
                              });
                          }) && f(u());
                      })
                    : void 0,
            T = function () {
                O &&
                    (O.disconnect(),
                    s.active &&
                        !s.paused &&
                        s.containers.map(function (t) {
                            O.observe(t, { subtree: !0, childList: !0 });
                        }));
            };
        return (
            (n = {
                get active() {
                    return s.active;
                },
                get paused() {
                    return s.paused;
                },
                activate: function (t) {
                    if (s.active) return this;
                    var e,
                        o = a(t, 'onActivate'),
                        l = a(t, 'onPostActivate'),
                        c = a(t, 'checkCanFocusTrap'),
                        u = ze.getActiveTrap(r),
                        f = !1;
                    u &&
                        !u.paused &&
                        (null === (e = u._setSubtreeIsolation) || void 0 === e || e.call(u, !1),
                        (f = !0));
                    try {
                        c || d(),
                            (s.active = !0),
                            (s.paused = !1),
                            (s.nodeFocusedBeforeActivation = h(i)),
                            null == o || o();
                        var p = (function () {
                            var t = Ne(
                                Le().m(function t() {
                                    return Le().w(function (t) {
                                        for (;;)
                                            switch (t.n) {
                                                case 0:
                                                    return c && d(), (t.n = 1), S();
                                                case 1:
                                                    n._setSubtreeIsolation(!0),
                                                        T(),
                                                        null == l || l();
                                                case 2:
                                                    return t.a(2);
                                            }
                                    }, t);
                                })
                            );
                            return function () {
                                return t.apply(this, arguments);
                            };
                        })();
                        if (c) return c(s.containers.concat()).then(p, p), this;
                        p();
                    } catch (v) {
                        var m;
                        if (u === ze.getActiveTrap(r) && f)
                            null === (m = u._setSubtreeIsolation) || void 0 === m || m.call(u, !0);
                        throw v;
                    }
                    return this;
                },
                deactivate: function (t) {
                    if (!s.active) return this;
                    var e = _e(
                        {
                            onDeactivate: o.onDeactivate,
                            onPostDeactivate: o.onPostDeactivate,
                            checkCanReturnFocus: o.checkCanReturnFocus,
                        },
                        t
                    );
                    clearTimeout(s.delayInitialFocusTimer),
                        (s.delayInitialFocusTimer = void 0),
                        s.paused || n._setSubtreeIsolation(!1),
                        s.alreadySilent.clear(),
                        E(),
                        (s.active = !1),
                        (s.paused = !1),
                        T(),
                        ze.deactivateTrap(r, n);
                    var i = a(e, 'onDeactivate'),
                        l = a(e, 'onPostDeactivate'),
                        c = a(e, 'checkCanReturnFocus'),
                        u = a(e, 'returnFocus', 'returnFocusOnDeactivate');
                    null == i || i();
                    var d = function () {
                        Be(function () {
                            u && f(p(s.nodeFocusedBeforeActivation)), null == l || l();
                        });
                    };
                    return u && c
                        ? (c(p(s.nodeFocusedBeforeActivation)).then(d, d), this)
                        : (d(), this);
                },
                pause: function (t) {
                    return s.active ? ((s.manuallyPaused = !0), this._setPausedState(!0, t)) : this;
                },
                unpause: function (t) {
                    return s.active
                        ? ((s.manuallyPaused = !1),
                          r[r.length - 1] !== this ? this : this._setPausedState(!1, t))
                        : this;
                },
                updateContainerElements: function (t) {
                    var e = [].concat(t).filter(Boolean);
                    return (
                        (s.containers = e.map(function (t) {
                            return 'string' == typeof t ? i.querySelector(t) : t;
                        })),
                        o.isolateSubtrees &&
                            (function (t) {
                                s.active && !s.paused && n._setSubtreeIsolation(!1),
                                    s.adjacentElements.clear(),
                                    s.alreadySilent.clear();
                                var e,
                                    i = new Set(),
                                    r = new Set(),
                                    o = De(t);
                                try {
                                    for (o.s(); !(e = o.n()).done; ) {
                                        var a = e.value;
                                        i.add(a);
                                        for (
                                            var l =
                                                    'undefined' != typeof ShadowRoot &&
                                                    a.getRootNode() instanceof ShadowRoot,
                                                c = a;
                                            c;

                                        ) {
                                            i.add(c);
                                            var u = c.parentElement,
                                                d = [];
                                            u
                                                ? (d = u.children)
                                                : !u &&
                                                  l &&
                                                  ((d = c.getRootNode().children),
                                                  (u = c.getRootNode().host),
                                                  (l =
                                                      'undefined' != typeof ShadowRoot &&
                                                      u.getRootNode() instanceof ShadowRoot));
                                            var h,
                                                f = De(d);
                                            try {
                                                for (f.s(); !(h = f.n()).done; ) {
                                                    var p = h.value;
                                                    r.add(p);
                                                }
                                            } catch (m) {
                                                f.e(m);
                                            } finally {
                                                f.f();
                                            }
                                            c = u;
                                        }
                                    }
                                } catch (m) {
                                    o.e(m);
                                } finally {
                                    o.f();
                                }
                                i.forEach(function (t) {
                                    r.delete(t);
                                }),
                                    (s.adjacentElements = r);
                            })(s.containers),
                        s.active && (d(), s.paused || n._setSubtreeIsolation(!0)),
                        T(),
                        this
                    );
                },
            }),
            Object.defineProperties(n, {
                _isManuallyPaused: {
                    value: function () {
                        return s.manuallyPaused;
                    },
                },
                _setPausedState: {
                    value: function (t, e) {
                        if (s.paused === t) return this;
                        if (((s.paused = t), t)) {
                            var i = a(e, 'onPause'),
                                r = a(e, 'onPostPause');
                            null == i || i(),
                                E(),
                                n._setSubtreeIsolation(!1),
                                T(),
                                null == r || r();
                        } else {
                            var o = a(e, 'onUnpause'),
                                l = a(e, 'onPostUnpause');
                            null == o || o();
                            var c = (function () {
                                var t = Ne(
                                    Le().m(function t() {
                                        return Le().w(function (t) {
                                            for (;;)
                                                switch (t.n) {
                                                    case 0:
                                                        return d(), (t.n = 1), S();
                                                    case 1:
                                                        n._setSubtreeIsolation(!0),
                                                            T(),
                                                            null == l || l();
                                                    case 2:
                                                        return t.a(2);
                                                }
                                        }, t);
                                    })
                                );
                                return function () {
                                    return t.apply(this, arguments);
                                };
                            })();
                            c();
                        }
                        return this;
                    },
                },
                _setSubtreeIsolation: {
                    value: function (t) {
                        o.isolateSubtrees &&
                            s.adjacentElements.forEach(function (e) {
                                var n;
                                if (t)
                                    if ('aria-hidden' === o.isolateSubtrees)
                                        ('true' !== e.ariaHidden &&
                                            'true' !==
                                                (null === (n = e.getAttribute('aria-hidden')) ||
                                                void 0 === n
                                                    ? void 0
                                                    : n.toLowerCase())) ||
                                            s.alreadySilent.add(e),
                                            e.setAttribute('aria-hidden', 'true');
                                    else
                                        (e.inert || e.hasAttribute('inert')) &&
                                            s.alreadySilent.add(e),
                                            e.setAttribute('inert', !0);
                                else if (s.alreadySilent.has(e));
                                else if ('aria-hidden' === o.isolateSubtrees)
                                    e.removeAttribute('aria-hidden');
                                else e.removeAttribute('inert');
                            });
                    },
                },
            }),
            n.updateContainerElements(t),
            n
        );
    };
function Ve(t) {
    (this.listenerMap = [{}, {}]),
        t && this.root(t),
        (this.handle = Ve.prototype.handle.bind(this)),
        (this._removedListeners = []);
}
function Ke(t, e) {
    return t.toLowerCase() === e.tagName.toLowerCase();
}
function Ze(t, e) {
    return this.rootElement === window
        ? e === document || e === document.documentElement || e === window
        : this.rootElement === e;
}
function Ye(t, e) {
    return t === e.id;
}
function Xe(t, e, n) {
    const i = document.createElement(e);
    return t && (i.className = t), n && n.appendChild(i), i;
}
function Je(t, e, n) {
    (t.style.width = 'number' == typeof e ? `${e}px` : e),
        (t.style.height = 'number' == typeof n ? `${n}px` : n);
}
(Ve.prototype.root = function (t) {
    const e = this.listenerMap;
    let n;
    if (this.rootElement) {
        for (n in e[1])
            e[1].hasOwnProperty(n) && this.rootElement.removeEventListener(n, this.handle, !0);
        for (n in e[0])
            e[0].hasOwnProperty(n) && this.rootElement.removeEventListener(n, this.handle, !1);
    }
    if (!t || !t.addEventListener) return this.rootElement && delete this.rootElement, this;
    for (n in ((this.rootElement = t), e[1]))
        e[1].hasOwnProperty(n) && this.rootElement.addEventListener(n, this.handle, !0);
    for (n in e[0]) e[0].hasOwnProperty(n) && this.rootElement.addEventListener(n, this.handle, !1);
    return this;
}),
    (Ve.prototype.captureForType = function (t) {
        return -1 !== ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(t);
    }),
    (Ve.prototype.on = function (t, e, n, i) {
        let r, o, s, a;
        if (!t) throw new TypeError('Invalid event type: ' + t);
        if (
            ('function' == typeof e && ((i = n), (n = e), (e = null)),
            void 0 === i && (i = this.captureForType(t)),
            'function' != typeof n)
        )
            throw new TypeError('Handler must be a type of Function');
        return (
            (r = this.rootElement),
            (o = this.listenerMap[i ? 1 : 0]),
            o[t] || (r && r.addEventListener(t, this.handle, i), (o[t] = [])),
            e
                ? /^[a-z]+$/i.test(e)
                    ? ((a = e), (s = Ke))
                    : /^#[a-z0-9\-_]+$/i.test(e)
                      ? ((a = e.slice(1)), (s = Ye))
                      : ((a = e), (s = Element.prototype.matches))
                : ((a = null), (s = Ze.bind(this))),
            o[t].push({ selector: e, handler: n, matcher: s, matcherParam: a }),
            this
        );
    }),
    (Ve.prototype.off = function (t, e, n, i) {
        let r, o, s, a, l;
        if (('function' == typeof e && ((i = n), (n = e), (e = null)), void 0 === i))
            return this.off(t, e, n, !0), this.off(t, e, n, !1), this;
        if (((s = this.listenerMap[i ? 1 : 0]), !t)) {
            for (l in s) s.hasOwnProperty(l) && this.off(l, e, n);
            return this;
        }
        if (((a = s[t]), !a || !a.length)) return this;
        for (r = a.length - 1; r >= 0; r--)
            (o = a[r]),
                (e && e !== o.selector) ||
                    (n && n !== o.handler) ||
                    (this._removedListeners.push(o), a.splice(r, 1));
        return (
            a.length ||
                (delete s[t],
                this.rootElement && this.rootElement.removeEventListener(t, this.handle, i)),
            this
        );
    }),
    (Ve.prototype.handle = function (t) {
        let e, n;
        const i = t.type;
        let r,
            o,
            s,
            a,
            l,
            c = [];
        const u = 'ftLabsDelegateIgnore';
        if (!0 === t[u]) return;
        switch (
            ((l = t.target),
            3 === l.nodeType && (l = l.parentNode),
            l.correspondingUseElement && (l = l.correspondingUseElement),
            (r = this.rootElement),
            (o = t.eventPhase || (t.target !== t.currentTarget ? 3 : 2)),
            o)
        ) {
            case 1:
                c = this.listenerMap[1][i];
                break;
            case 2:
                this.listenerMap[0] &&
                    this.listenerMap[0][i] &&
                    (c = c.concat(this.listenerMap[0][i])),
                    this.listenerMap[1] &&
                        this.listenerMap[1][i] &&
                        (c = c.concat(this.listenerMap[1][i]));
                break;
            case 3:
                c = this.listenerMap[0][i];
        }
        let d,
            h = [];
        for (n = c.length; l && n; ) {
            for (e = 0; e < n && ((s = c[e]), s); e++)
                l.tagName &&
                ['button', 'input', 'select', 'textarea'].indexOf(l.tagName.toLowerCase()) > -1 &&
                l.hasAttribute('disabled')
                    ? (h = [])
                    : s.matcher.call(l, s.matcherParam, l) && h.push([t, l, s]);
            if (l === r) break;
            if (((n = c.length), (l = l.parentElement || l.parentNode), l instanceof HTMLDocument))
                break;
        }
        for (e = 0; e < h.length; e++)
            if (
                !(this._removedListeners.indexOf(h[e][2]) > -1) &&
                ((a = this.fire.apply(this, h[e])), !1 === a)
            ) {
                (h[e][0][u] = !0), h[e][0].preventDefault(), (d = !1);
                break;
            }
        return d;
    }),
    (Ve.prototype.fire = function (t, e, n) {
        return n.handler.call(e, t, e);
    }),
    (Ve.prototype.destroy = function () {
        this.off(), this.root();
    });
const Qe = 'idle',
    tn = 'loading',
    en = 'loaded',
    nn = 'error';
function rn(t, e, n = document) {
    let i = [];
    if (t instanceof Element) i = [t];
    else if (t instanceof NodeList || Array.isArray(t)) i = Array.from(t);
    else {
        const r = 'string' == typeof t ? t : e;
        r && (i = Array.from(n.querySelectorAll(r)));
    }
    return i;
}
function on() {
    return !(!navigator.vendor || !navigator.vendor.match(/apple/i));
}
class sn {
    constructor(t, e) {
        (this.type = t), (this.defaultPrevented = !1), e && Object.assign(this, e);
    }
    preventDefault() {
        this.defaultPrevented = !0;
    }
}
class an {
    constructor() {
        (this._listeners = {}), (this._filters = {}), (this.pswp = void 0), (this.options = void 0);
    }
    addFilter(t, e, n = 100) {
        var i, r, o;
        this._filters[t] || (this._filters[t] = []),
            null === (i = this._filters[t]) || void 0 === i || i.push({ fn: e, priority: n }),
            null === (r = this._filters[t]) ||
                void 0 === r ||
                r.sort((t, e) => t.priority - e.priority),
            null === (o = this.pswp) || void 0 === o || o.addFilter(t, e, n);
    }
    removeFilter(t, e) {
        this._filters[t] && (this._filters[t] = this._filters[t].filter(t => t.fn !== e)),
            this.pswp && this.pswp.removeFilter(t, e);
    }
    applyFilters(t, ...e) {
        var n;
        return (
            null === (n = this._filters[t]) ||
                void 0 === n ||
                n.forEach(t => {
                    e[0] = t.fn.apply(this, e);
                }),
            e[0]
        );
    }
    on(t, e) {
        var n, i;
        this._listeners[t] || (this._listeners[t] = []),
            null === (n = this._listeners[t]) || void 0 === n || n.push(e),
            null === (i = this.pswp) || void 0 === i || i.on(t, e);
    }
    off(t, e) {
        var n;
        this._listeners[t] && (this._listeners[t] = this._listeners[t].filter(t => e !== t)),
            null === (n = this.pswp) || void 0 === n || n.off(t, e);
    }
    dispatch(t, e) {
        var n;
        if (this.pswp) return this.pswp.dispatch(t, e);
        const i = new sn(t, e);
        return (
            null === (n = this._listeners[t]) ||
                void 0 === n ||
                n.forEach(t => {
                    t.call(this, i);
                }),
            i
        );
    }
}
class ln {
    constructor(t, e) {
        if (((this.element = Xe('pswp__img pswp__img--placeholder', t ? 'img' : 'div', e)), t)) {
            const e = this.element;
            (e.decoding = 'async'),
                (e.alt = ''),
                (e.src = t),
                e.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
    }
    setDisplayedSize(t, e) {
        this.element &&
            ('IMG' === this.element.tagName
                ? (Je(this.element, 250, 'auto'),
                  (this.element.style.transformOrigin = '0 0'),
                  (this.element.style.transform = (function (t, e, n) {
                      let i = `translate3d(${t}px,0px,0)`;
                      return void 0 !== n && (i += ` scale3d(${n},${n},1)`), i;
                  })(0, 0, t / 250)))
                : Je(this.element, t, e));
    }
    destroy() {
        var t;
        null !== (t = this.element) && void 0 !== t && t.parentNode && this.element.remove(),
            (this.element = null);
    }
}
class cn {
    constructor(t, e, n) {
        (this.instance = e),
            (this.data = t),
            (this.index = n),
            (this.element = void 0),
            (this.placeholder = void 0),
            (this.slide = void 0),
            (this.displayedImageWidth = 0),
            (this.displayedImageHeight = 0),
            (this.width = Number(this.data.w) || Number(this.data.width) || 0),
            (this.height = Number(this.data.h) || Number(this.data.height) || 0),
            (this.isAttached = !1),
            (this.hasSlide = !1),
            (this.isDecoding = !1),
            (this.state = Qe),
            this.data.type
                ? (this.type = this.data.type)
                : this.data.src
                  ? (this.type = 'image')
                  : (this.type = 'html'),
            this.instance.dispatch('contentInit', { content: this });
    }
    removePlaceholder() {
        this.placeholder &&
            !this.keepPlaceholder() &&
            setTimeout(() => {
                this.placeholder && (this.placeholder.destroy(), (this.placeholder = void 0));
            }, 1e3);
    }
    load(t, e) {
        if (this.slide && this.usePlaceholder())
            if (this.placeholder) {
                const t = this.placeholder.element;
                t && !t.parentElement && this.slide.container.prepend(t);
            } else {
                const t = this.instance.applyFilters(
                    'placeholderSrc',
                    !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc,
                    this
                );
                this.placeholder = new ln(t, this.slide.container);
            }
        (this.element && !e) ||
            this.instance.dispatch('contentLoad', { content: this, isLazy: t }).defaultPrevented ||
            (this.isImageContent()
                ? ((this.element = Xe('pswp__img', 'img')),
                  this.displayedImageWidth && this.loadImage(t))
                : ((this.element = Xe('pswp__content', 'div')),
                  (this.element.innerHTML = this.data.html || '')),
            e && this.slide && this.slide.updateContentSize(!0));
    }
    loadImage(t) {
        var e, n;
        if (
            !this.isImageContent() ||
            !this.element ||
            this.instance.dispatch('contentLoadImage', { content: this, isLazy: t })
                .defaultPrevented
        )
            return;
        const i = this.element;
        this.updateSrcsetSizes(),
            this.data.srcset && (i.srcset = this.data.srcset),
            (i.src = null !== (e = this.data.src) && void 0 !== e ? e : ''),
            (i.alt = null !== (n = this.data.alt) && void 0 !== n ? n : ''),
            (this.state = tn),
            i.complete
                ? this.onLoaded()
                : ((i.onload = () => {
                      this.onLoaded();
                  }),
                  (i.onerror = () => {
                      this.onError();
                  }));
    }
    setSlide(t) {
        (this.slide = t), (this.hasSlide = !0), (this.instance = t.pswp);
    }
    onLoaded() {
        (this.state = en),
            this.slide &&
                this.element &&
                (this.instance.dispatch('loadComplete', { slide: this.slide, content: this }),
                this.slide.isActive &&
                    this.slide.heavyAppended &&
                    !this.element.parentNode &&
                    (this.append(), this.slide.updateContentSize(!0)),
                (this.state !== en && this.state !== nn) || this.removePlaceholder());
    }
    onError() {
        (this.state = nn),
            this.slide &&
                (this.displayError(),
                this.instance.dispatch('loadComplete', {
                    slide: this.slide,
                    isError: !0,
                    content: this,
                }),
                this.instance.dispatch('loadError', { slide: this.slide, content: this }));
    }
    isLoading() {
        return this.instance.applyFilters('isContentLoading', this.state === tn, this);
    }
    isError() {
        return this.state === nn;
    }
    isImageContent() {
        return 'image' === this.type;
    }
    setDisplayedSize(t, e) {
        if (
            this.element &&
            (this.placeholder && this.placeholder.setDisplayedSize(t, e),
            !this.instance.dispatch('contentResize', { content: this, width: t, height: e })
                .defaultPrevented &&
                (Je(this.element, t, e), this.isImageContent() && !this.isError()))
        ) {
            const n = !this.displayedImageWidth && t;
            (this.displayedImageWidth = t),
                (this.displayedImageHeight = e),
                n ? this.loadImage(!1) : this.updateSrcsetSizes(),
                this.slide &&
                    this.instance.dispatch('imageSizeChange', {
                        slide: this.slide,
                        width: t,
                        height: e,
                        content: this,
                    });
        }
    }
    isZoomable() {
        return this.instance.applyFilters(
            'isContentZoomable',
            this.isImageContent() && this.state !== nn,
            this
        );
    }
    updateSrcsetSizes() {
        if (!this.isImageContent() || !this.element || !this.data.srcset) return;
        const t = this.element,
            e = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
        (!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) &&
            ((t.sizes = e + 'px'), (t.dataset.largestUsedSize = String(e)));
    }
    usePlaceholder() {
        return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
    }
    lazyLoad() {
        this.instance.dispatch('contentLazyLoad', { content: this }).defaultPrevented ||
            this.load(!0);
    }
    keepPlaceholder() {
        return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
    }
    destroy() {
        (this.hasSlide = !1),
            (this.slide = void 0),
            this.instance.dispatch('contentDestroy', { content: this }).defaultPrevented ||
                (this.remove(),
                this.placeholder && (this.placeholder.destroy(), (this.placeholder = void 0)),
                this.isImageContent() &&
                    this.element &&
                    ((this.element.onload = null),
                    (this.element.onerror = null),
                    (this.element = void 0)));
    }
    displayError() {
        if (this.slide) {
            var t, e;
            let n = Xe('pswp__error-msg', 'div');
            (n.innerText =
                null !==
                    (t =
                        null === (e = this.instance.options) || void 0 === e
                            ? void 0
                            : e.errorMsg) && void 0 !== t
                    ? t
                    : ''),
                (n = this.instance.applyFilters('contentErrorElement', n, this)),
                (this.element = Xe('pswp__content pswp__error-msg-container', 'div')),
                this.element.appendChild(n),
                (this.slide.container.innerText = ''),
                this.slide.container.appendChild(this.element),
                this.slide.updateContentSize(!0),
                this.removePlaceholder();
        }
    }
    append() {
        if (this.isAttached || !this.element) return;
        if (((this.isAttached = !0), this.state === nn)) return void this.displayError();
        if (this.instance.dispatch('contentAppend', { content: this }).defaultPrevented) return;
        const t = 'decode' in this.element;
        this.isImageContent()
            ? t && this.slide && (!this.slide.isActive || on())
                ? ((this.isDecoding = !0),
                  this.element
                      .decode()
                      .catch(() => {})
                      .finally(() => {
                          (this.isDecoding = !1), this.appendImage();
                      }))
                : this.appendImage()
            : this.slide &&
              !this.element.parentNode &&
              this.slide.container.appendChild(this.element);
    }
    activate() {
        !this.instance.dispatch('contentActivate', { content: this }).defaultPrevented &&
            this.slide &&
            (this.isImageContent() && this.isDecoding && !on()
                ? this.appendImage()
                : this.isError() && this.load(!1, !0),
            this.slide.holderElement &&
                this.slide.holderElement.setAttribute('aria-hidden', 'false'));
    }
    deactivate() {
        this.instance.dispatch('contentDeactivate', { content: this }),
            this.slide &&
                this.slide.holderElement &&
                this.slide.holderElement.setAttribute('aria-hidden', 'true');
    }
    remove() {
        (this.isAttached = !1),
            this.instance.dispatch('contentRemove', { content: this }).defaultPrevented ||
                (this.element && this.element.parentNode && this.element.remove(),
                this.placeholder && this.placeholder.element && this.placeholder.element.remove());
    }
    appendImage() {
        this.isAttached &&
            (this.instance.dispatch('contentAppendImage', { content: this }).defaultPrevented ||
                (this.slide &&
                    this.element &&
                    !this.element.parentNode &&
                    this.slide.container.appendChild(this.element),
                (this.state !== en && this.state !== nn) || this.removePlaceholder()));
    }
}
function un(t, e, n, i, r) {
    let o = 0;
    if (e.paddingFn) o = e.paddingFn(n, i, r)[t];
    else if (e.padding) o = e.padding[t];
    else {
        const n = 'padding' + t[0].toUpperCase() + t.slice(1);
        e[n] && (o = e[n]);
    }
    return Number(o) || 0;
}
class dn {
    constructor(t, e, n, i) {
        (this.pswp = i),
            (this.options = t),
            (this.itemData = e),
            (this.index = n),
            (this.panAreaSize = null),
            (this.elementSize = null),
            (this.fit = 1),
            (this.fill = 1),
            (this.vFill = 1),
            (this.initial = 1),
            (this.secondary = 1),
            (this.max = 1),
            (this.min = 1);
    }
    update(t, e, n) {
        const i = { x: t, y: e };
        (this.elementSize = i), (this.panAreaSize = n);
        const r = n.x / i.x,
            o = n.y / i.y;
        (this.fit = Math.min(1, r < o ? r : o)),
            (this.fill = Math.min(1, r > o ? r : o)),
            (this.vFill = Math.min(1, o)),
            (this.initial = this._getInitial()),
            (this.secondary = this._getSecondary()),
            (this.max = Math.max(this.initial, this.secondary, this._getMax())),
            (this.min = Math.min(this.fit, this.initial, this.secondary)),
            this.pswp &&
                this.pswp.dispatch('zoomLevelsUpdate', {
                    zoomLevels: this,
                    slideData: this.itemData,
                });
    }
    _parseZoomLevelOption(t) {
        const e = t + 'ZoomLevel',
            n = this.options[e];
        if (n)
            return 'function' == typeof n
                ? n(this)
                : 'fill' === n
                  ? this.fill
                  : 'fit' === n
                    ? this.fit
                    : Number(n);
    }
    _getSecondary() {
        let t = this._parseZoomLevelOption('secondary');
        return (
            t ||
            ((t = Math.min(1, 3 * this.fit)),
            this.elementSize && t * this.elementSize.x > 4e3 && (t = 4e3 / this.elementSize.x),
            t)
        );
    }
    _getInitial() {
        return this._parseZoomLevelOption('initial') || this.fit;
    }
    _getMax() {
        return this._parseZoomLevelOption('max') || Math.max(1, 4 * this.fit);
    }
}
function hn(t, e, n) {
    const i = e.createContentFromData(t, n);
    let r;
    const { options: o } = e;
    if (o) {
        let s;
        (r = new dn(o, t, -1)),
            (s = e.pswp
                ? e.pswp.viewportSize
                : (function (t, e) {
                      if (t.getViewportSizeFn) {
                          const n = t.getViewportSizeFn(t, e);
                          if (n) return n;
                      }
                      return { x: document.documentElement.clientWidth, y: window.innerHeight };
                  })(o, e));
        const a = (function (t, e, n, i) {
            return {
                x: e.x - un('left', t, e, n, i) - un('right', t, e, n, i),
                y: e.y - un('top', t, e, n, i) - un('bottom', t, e, n, i),
            };
        })(o, s, t, n);
        r.update(i.width, i.height, a);
    }
    return (
        i.lazyLoad(),
        r && i.setDisplayedSize(Math.ceil(i.width * r.initial), Math.ceil(i.height * r.initial)),
        i
    );
}
class fn extends an {
    getNumItems() {
        var t;
        let e = 0;
        const n = null === (t = this.options) || void 0 === t ? void 0 : t.dataSource;
        n && 'length' in n
            ? (e = n.length)
            : n &&
              'gallery' in n &&
              (n.items || (n.items = this._getGalleryDOMElements(n.gallery)),
              n.items && (e = n.items.length));
        const i = this.dispatch('numItems', { dataSource: n, numItems: e });
        return this.applyFilters('numItems', i.numItems, n);
    }
    createContentFromData(t, e) {
        return new cn(t, this, e);
    }
    getItemData(t) {
        var e;
        const n = null === (e = this.options) || void 0 === e ? void 0 : e.dataSource;
        let i = {};
        Array.isArray(n)
            ? (i = n[t])
            : n &&
              'gallery' in n &&
              (n.items || (n.items = this._getGalleryDOMElements(n.gallery)), (i = n.items[t]));
        let r = i;
        r instanceof Element && (r = this._domElementToItemData(r));
        const o = this.dispatch('itemData', { itemData: r || {}, index: t });
        return this.applyFilters('itemData', o.itemData, t);
    }
    _getGalleryDOMElements(t) {
        var e, n;
        return (null !== (e = this.options) && void 0 !== e && e.children) ||
            (null !== (n = this.options) && void 0 !== n && n.childSelector)
            ? rn(this.options.children, this.options.childSelector, t) || []
            : [t];
    }
    _domElementToItemData(t) {
        const e = { element: t },
            n = 'A' === t.tagName ? t : t.querySelector('a');
        if (n) {
            (e.src = n.dataset.pswpSrc || n.href),
                n.dataset.pswpSrcset && (e.srcset = n.dataset.pswpSrcset),
                (e.width = n.dataset.pswpWidth ? parseInt(n.dataset.pswpWidth, 10) : 0),
                (e.height = n.dataset.pswpHeight ? parseInt(n.dataset.pswpHeight, 10) : 0),
                (e.w = e.width),
                (e.h = e.height),
                n.dataset.pswpType && (e.type = n.dataset.pswpType);
            const r = t.querySelector('img');
            var i;
            if (r)
                (e.msrc = r.currentSrc || r.src),
                    (e.alt = null !== (i = r.getAttribute('alt')) && void 0 !== i ? i : '');
            (n.dataset.pswpCropped || n.dataset.cropped) && (e.thumbCropped = !0);
        }
        return this.applyFilters('domItemData', e, t, n);
    }
    lazyLoadData(t, e) {
        return hn(t, this, e);
    }
}
class pn extends fn {
    constructor(t) {
        super(),
            (this.options = t || {}),
            (this._uid = 0),
            (this.shouldOpen = !1),
            (this._preloadedContent = void 0),
            (this.onThumbnailsClick = this.onThumbnailsClick.bind(this));
    }
    init() {
        rn(this.options.gallery, this.options.gallerySelector).forEach(t => {
            t.addEventListener('click', this.onThumbnailsClick, !1);
        });
    }
    onThumbnailsClick(t) {
        if (
            (function (t) {
                return (
                    ('button' in t && 1 === t.button) ||
                    t.ctrlKey ||
                    t.metaKey ||
                    t.altKey ||
                    t.shiftKey
                );
            })(t) ||
            window.pswp
        )
            return;
        let e = { x: t.clientX, y: t.clientY };
        e.x || e.y || (e = null);
        let n = this.getClickedIndex(t);
        n = this.applyFilters('clickedIndex', n, t, this);
        const i = { gallery: t.currentTarget };
        n >= 0 && (t.preventDefault(), this.loadAndOpen(n, i, e));
    }
    getClickedIndex(t) {
        if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, t);
        const e = t.target,
            n = rn(this.options.children, this.options.childSelector, t.currentTarget).findIndex(
                t => t === e || t.contains(e)
            );
        return -1 !== n ? n : this.options.children || this.options.childSelector ? -1 : 0;
    }
    loadAndOpen(t, e, n) {
        if (window.pswp || !this.options) return !1;
        if (!e && this.options.gallery && this.options.children) {
            const t = rn(this.options.gallery);
            t[0] && (e = { gallery: t[0] });
        }
        return (
            (this.options.index = t),
            (this.options.initialPointerPos = n),
            (this.shouldOpen = !0),
            this.preload(t, e),
            !0
        );
    }
    preload(t, e) {
        const { options: n } = this;
        e && (n.dataSource = e);
        const i = [],
            r = typeof n.pswpModule;
        if ('function' == typeof (o = n.pswpModule) && o.prototype && o.prototype.goTo)
            i.push(Promise.resolve(n.pswpModule));
        else {
            if ('string' === r) throw new Error('pswpModule as string is no longer supported');
            if ('function' !== r) throw new Error('pswpModule is not valid');
            i.push(n.pswpModule());
        }
        var o;
        'function' == typeof n.openPromise && i.push(n.openPromise()),
            !1 !== n.preloadFirstSlide &&
                t >= 0 &&
                (this._preloadedContent = (function (t, e) {
                    const n = e.getItemData(t);
                    if (!e.dispatch('lazyLoadSlide', { index: t, itemData: n }).defaultPrevented)
                        return hn(n, e, t);
                })(t, this));
        const s = ++this._uid;
        Promise.all(i).then(t => {
            if (this.shouldOpen) {
                const e = t[0];
                this._openPhotoswipe(e, s);
            }
        });
    }
    _openPhotoswipe(t, e) {
        if (e !== this._uid && this.shouldOpen) return;
        if (((this.shouldOpen = !1), window.pswp)) return;
        const n = 'object' == typeof t ? new t.default(this.options) : new t(this.options);
        (this.pswp = n),
            (window.pswp = n),
            Object.keys(this._listeners).forEach(t => {
                var e;
                null === (e = this._listeners[t]) ||
                    void 0 === e ||
                    e.forEach(e => {
                        n.on(t, e);
                    });
            }),
            Object.keys(this._filters).forEach(t => {
                var e;
                null === (e = this._filters[t]) ||
                    void 0 === e ||
                    e.forEach(e => {
                        n.addFilter(t, e.fn, e.priority);
                    });
            }),
            this._preloadedContent &&
                (n.contentLoader.addToCache(this._preloadedContent),
                (this._preloadedContent = void 0)),
            n.on('destroy', () => {
                (this.pswp = void 0), delete window.pswp;
            }),
            n.init();
    }
    destroy() {
        var t;
        null === (t = this.pswp) || void 0 === t || t.destroy(),
            (this.shouldOpen = !1),
            (this._listeners = {}),
            rn(this.options.gallery, this.options.gallerySelector).forEach(t => {
                t.removeEventListener('click', this.onThumbnailsClick, !1);
            });
    }
}
export {
    Ve as Delegate,
    He as FocusTrap,
    pn as PhotoSwipeLightbox,
    te as animate,
    yt as animateSequence,
    re as frame,
    It as inView,
    Jt as scroll,
    Pt as spring,
    ct as stagger,
};
